import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import { requestDemoInvisionSwitchId } from 'marketing-website/configs/hubspot';

import Heading from '@marvelapp/marvel-ui/heading';
import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import Image from 'marketing-website/components/modules/Image';

import styles from './style/header.module.css';

export default function Header({
  heading,
  subHeading,
  headerImage,
  mainColor,
}) {
  const requestDemoUrl = `/enterprise/request-demo?hformid=${requestDemoInvisionSwitchId}`;

  const buttons = (
    <Spacing size="m" sizeM="l" position="top" type="margin">
      <div className={styles.buttons}>
        <div className={styles.leftButton}>
          <Link to={requestDemoUrl}>
            <Button
              size="large"
              background={mainColor}
              hover={mainColor}
              shape="rounded"
              minWidth={180}
            >
              Request a demo
            </Button>
          </Link>
        </div>
      </div>
    </Spacing>
  );

  return (
    <PageWrap size="l">
      <div className={styles.flex}>
        <div className={styles.firstCol}>
          <div>
            <Heading tag="h1" size="xxxxl" weight="bold" color="black">
              {heading}
            </Heading>
            <Spacing size="s" position="top" type="margin">
              <Heading tag="h2" size="xxl">
                {subHeading}
              </Heading>
            </Spacing>
            {buttons}
          </div>
        </div>
        <div className={styles.secondCol}>
          <div className={styles.coloredBackground}>
            {mainColor === 'blue' && <div className={styles.blueChild} />}
            {mainColor === 'green' && <div className={styles.greenChild} />}
          </div>
          <div className={styles.image}>
            <div className={styles.imageChild}>
              <Image {...headerImage} hasShadow={false} block />
            </div>
          </div>
        </div>
      </div>
    </PageWrap>
  );
}

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
  headerImage: PropTypes.object.isRequired,
  mainColor: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/CompetitorAlternatives/Header.js